var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_add_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.371 14.67c.22 2.057 1.876 3.713 3.933 3.942 3.16.352 6.232.352 9.392 0 2.057-.23 3.713-1.885 3.933-3.943.162-1.519.3-3.079.3-4.669 0-1.59-.138-3.15-.3-4.67-.22-2.057-1.876-3.713-3.933-3.942a41.877 41.877 0 0 0-9.392 0c-2.057.23-3.713 1.885-3.933 3.943-.162 1.519-.3 3.079-.3 4.669 0 1.59.138 3.15.3 4.67Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6.429v7.142M13.571 10H6.43",
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_add_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWebappAdd;